import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button } from '@/js/libs/ui/index.ts';
import { Wrapper, Title } from './styes.js';
export const Error = memo(function Error({ title = 'Unknown error', onRetryClick, pending = false, retryLabel = 'Retry', }) {
    return (_jsxs(Wrapper, { children: [_jsx(Title, { children: title }), onRetryClick && (_jsx(Button, { type: 'button', isLoading: pending, onClick: onRetryClick, variant: 'create-secondary', "data-testid": 'retry-button', children: retryLabel }))] }));
});
